import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './styles.css';
import { getJwtToken } from '../Authorization/actions';

const HelpLink = ({ idPrefix, current }) => (
  <a
    href={`${process.env.API_URL}/help/redirect?auth=${getJwtToken(current.viewer)}`}
    target="_blank"
    id="js-helpUserMenu-help-menu-link"
    styleName="helpUserMenu-help-menu-link"
    rel="noopener noreferrer"
  >
    {
      idPrefix === 'helpUserMenu' ?
        <FormattedMessage id="app.secondaryMenu.help" defaultMessage="Help" /> : <FormattedMessage id="app.topNavMenu.help" defaultMessage="Help Center" />
    }
  </a>
);
HelpLink.propTypes = {
  idPrefix: PropTypes.string,
  current: PropTypes.shape({
    viewer: PropTypes.shape({
      jwtToken: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  current: state.current,
});

export default connect(mapStateToProps)(HelpLink);
